import React from 'react';

class BackgroundColor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      background_type: props.background_type,
      background_color: props.background_color,
    };
  }

  shouldComponentUpdate(nextProps) {
    const bg = document.querySelector('#hu-background .hu-background-color');
    if (nextProps.background_type !== 'color')
      bg.className = bg.className.replace(/\sselected/g, '');
    else 
      bg.className = 'hu-background-color' + ' selected';
    return false;
  }

  render() {
    const { background_type, background_color } = this.props;
    const selected = background_type === 'color';
    
    return (
      <div className={ selected ? 'hu-background-color selected' : 'hu-background-color' }></div>
    );
  }
}

export default BackgroundColor;


// WEBPACK FOOTER //
// ./app/js/components/background/BackgroundColor.js